import React from "react";
import {
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import DoneIcon from "@mui/icons-material/Done";
import NotificationsIcon from "@mui/icons-material/Notifications";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/id";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { pksAction } from "state/reducer/pks";
import { invoiceAction } from "state/reducer/invoice";

dayjs.extend(relativeTime);

const StyledListItem = styled(ListItem)(({ theme, read }) => ({
  backgroundColor: read ? "transparent" : theme.palette.action.hover,
  "&:hover": {
    backgroundColor: theme.palette.action.selected,
  },
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const NotificationItem = ({ notification, onMarkAsRead }) => {
  const { _id, title, message, created_at, read, type, link, data } =
    notification;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getNotificationIcon = () => {
    // Customize based on notification type
    switch (type) {
      case "alert":
        return <NotificationsIcon color="error" />;
      case "info":
        return <NotificationsIcon color="info" />;
      default:
        return <NotificationsIcon color="primary" />;
    }
  };

  return (
    <StyledListItem
      read={read ? 1 : 0}
      onClick={() => {
        onMarkAsRead(_id);
        dispatch(invoiceAction.setSelectedInvoice(data));
        // note: invoice detail loads by ?id=, so carry the id for links that don't have one
        navigate(
          link === "/invoice/detail" && data?._id
            ? `${link}?id=${data._id}`
            : link,
        );
      }}
      sx={{ bgColor: read ? "white" : "grey" }}
      // secondaryAction={
      //   !read && (
      //     <IconButton
      //       edge="end"
      //       aria-label="mark as read"
      //       // onClick={() => onMarkAsRead(id)}
      //     >
      //       <DoneIcon fontSize="small" />
      //     </IconButton>
      //   )
      // }
    >
      <ListItemText
        primary={
          <Typography
            variant="subtitle2"
            color={read ? "textSecondary" : "textPrimary"}
          >
            {title}
          </Typography>
        }
        secondary={
          <>
            <Typography
              component="span"
              variant="body2"
              color="textSecondary"
              sx={{ display: "block" }}
            >
              {message}
            </Typography>
            <Typography
              component="span"
              variant="caption"
              color="textSecondary"
              sx={{ display: "block", mt: 0.5 }}
            >
              {dayjs(created_at).locale("id").fromNow()}
            </Typography>
          </>
        }
      />
    </StyledListItem>
  );
};

export default NotificationItem;
